import { render, staticRenderFns } from "./chayi-duli-fenlei.vue?vue&type=template&id=57610ef2&"
import script from "./chayi-duli-fenlei.vue?vue&type=script&lang=ts&"
export * from "./chayi-duli-fenlei.vue?vue&type=script&lang=ts&"
import style0 from "./chayi-duli-fenlei.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports